<template lang="html">

  <section class="ficha -observaciones">

    <h2 class="ficha-title" :style="styles.colorBasic">{{$t('observaciones')}}</h2>

    <template v-for="(observacion, key) in observaciones" v-if="observaciones.length > 0">
      <observacion-el :data="observacion"></observacion-el>
    </template>

    <template>
      <template v-for="(observacion, key) in observacionesManuales"  v-if="observacionesManuales.length > 0">
        <observacion-manual-el :data="observacion"></observacion-manual-el>
      </template>
       <div class="contenedor-botones row-center" :style="styles.backgroundWhite" style="width: 100%; padding: 25px;">
        <a class="btn -xs" :style="styles.solidPrimary" @click="showPopupObservacionManual = true">{{$t('add_observacion')}}</a>
      </div>
    </template>
    
    <popup-observacion-manual v-if="showPopupObservacionManual" @cerrar="showPopupObservacionManual = false"    @observacionAnnadida="$emit('observacionAnnadida')"></popup-observacion-manual>     
    

    <template v-if="observaciones.length == 0 && observacionesManuales.length == 0">
      <p>{{$t('no_tiene_observaciones')}}</p>
    </template>
    

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import observacion from '@/components/parts/observacion-el';

  import observacionManual from '@/components/parts/observacion-manual-el';

  import popupObservacionManual from '@/components/parts/popup-observacion-manual';
  
  export default  {
    name: 'ficha-observaciones',
    props : ['observaciones', 'observacionesManuales'],
    data(){
      return{
        
        documentacion : [],
        showPopupObservacionManual: false,
      }
    },
    mounted(){

    },
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        brand : 'getBrand', 
      })
    },
    methods : {
    	...mapActions(['dameContestacionEncuesta']),
    },
    components : {
      'observacion-el' : observacion,
      'observacion-manual-el' : observacionManual,
      'popup-observacion-manual': popupObservacionManual,
    }
  }
</script>

<style scoped lang="scss">
  .ficha.-observaciones {
    .ficha-title{
      margin-top: 5px;

      &.-documentacion-practica{
        margin-top: 20px;
      }
    }

    p{
      text-align: left;
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }

    .add-documentacion{
      cursor: pointer;
      margin-top: 10px;
    }
  }
  


</style>



// WEBPACK FOOTER //
// src/components/views/ficha-observaciones.vue